import React from 'react';
import { ROUTE_SETTINGS_USERS } from 'routes/RouteList';
import {
  QUERY_GET_USERS_BY_ENTITY_ID,
  REMOVE_PERSON_FROM_ENTITY
} from 'services/aws/user-query';
import Icon from 'components/icon/Icon';
import ConfirmMutationButton from './ConfirmMutationButton';
import messages from 'messages';
import { generatePath, useHistory } from 'react-router-dom';

const RemoveUserButton = ({ entityId, userId, children, ...props }) => {
  const { push } = useHistory();
  return (
    <ConfirmMutationButton
      {...props}
      mutation={REMOVE_PERSON_FROM_ENTITY}
      variables={{
        personId: userId,
        entityId
      }}
      confirmTitle={messages.modalConfirmRemoveUserTitle}
      confirmMessage={messages.modalConfirmRemoveUserMessage}
      refetchQueries={[
        {
          query: QUERY_GET_USERS_BY_ENTITY_ID,
          variables: { id: entityId }
        }
      ]}
      update={(cache, { data: { removePersonFromEntity } }) => {
        if (removePersonFromEntity) {
          push(
            generatePath(ROUTE_SETTINGS_USERS, {
              setting: 'users',
              entityId
            })
          );
        }
      }}
    >
      <Icon id="delete" />
      {children}
    </ConfirmMutationButton>
  );
};

export default RemoveUserButton;
